import React from 'react'
import loadable from '@loadable/component'

const ImageDeprecated = loadable(() => import('@components/Image-deprecated'))

const Image = ({ url, props, classes, alt, width, maxWidth, height }) => {
  if (!url) {
    return (
      <ImageDeprecated
        props={props}
        classes={classes}
        alt={alt}
        width={width}
        maxWidth={maxWidth}
        height={height}
      />
    )
  }

  return (
    <img
      loading='lazy'
      src={`${url}?auto=format&fit=max${
        width && !maxWidth ? `&w=${width}` : ''
      }${maxWidth ? `&w=${maxWidth}` : ''}${height ? `&h=${height}` : ''}`}
      alt={alt || ''}
      className={classes}
      width={width && width !== null ? width : 'auto'}
      height={height && height !== null ? height : 'auto'}
    />
  )
}
export default Image
